module.exports = __webpack_public_path__ + "img/heart.c2e58c2c.svg";